<script setup lang="ts">
defineProps<{ step: number }>();

const labels = ['Code', 'Account', 'Done'];
</script>

<template>
  <ol class="steps">
    <li
      v-for="(label, i) in labels"
      :key="label"
      :class="[
        'step',
        { active: i === step, complete: i < step },
      ]"
    >
      <span class="dot">
        <span v-if="i < step" class="check" aria-hidden="true">
          <svg viewBox="0 0 16 16" width="10" height="10">
            <path
              d="M3 8.5 L7 12 L13 4"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <span v-else class="num">{{ i + 1 }}</span>
      </span>
      <span class="label">{{ label }}</span>
    </li>
  </ol>
</template>

<style scoped>
.steps {
  list-style: none;
  padding: 0;
  margin: 0 0 1.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
}
.step {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: var(--ink-mute);
}
.step:not(:last-child)::after {
  content: '';
  display: inline-block;
  width: 1.5rem;
  height: 1px;
  background: var(--coco-200);
  margin-left: 0.4rem;
}
.dot {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--coco-100);
  color: var(--coco-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.78rem;
  transition: background 160ms var(--ease), color 160ms var(--ease);
}
.label {
  letter-spacing: 0.02em;
  font-weight: 500;
}
.step.active .dot {
  background: var(--lime-500);
  color: var(--coco-900);
  box-shadow: 0 0 0 4px var(--lime-100);
}
.step.active .label {
  color: var(--ink);
}
.step.complete .dot {
  background: var(--lime-700);
  color: var(--cream);
}
.step.complete .label {
  color: var(--coco-700);
}
</style>
